import { css as t, createGlobalStyle as r } from "styled-components";
import o from "./colors.js";
const f = t`
  --blue: ${o.teal50};
  --yellow-bright: ${o.yellow15};
  --logo-orange: ${o.logoOrange};
  --orange: ${o.orange};
  --blue-grey: ${o.blueGrey};
  --grey: ${o.blueGrey75};
  --bluey-grey: ${o.blueGrey};
  --light-blue-grey: ${o.blueGrey25}
  --very-light-blue: ${o.blueGrey10};
  --black: ${o.darkGrey};
  --dark-grey: ${o.darkGrey75};
  --blue-grey-two: ${o.darkGrey50};
  --light-blue-grey-two: ${o.darkGrey25};
  --disabled-grey: ${o.darkGrey10};
  --error-red: ${o.red};
  --visited-text-link: ${o.teal};
  --success-green: ${o.green};
  --text-link: ${o.brown};
  --white: ${o.white};

  @font-face {
    font-family: VIC;
    src: local(VIC-Regular),
    url(${(e) => e.theme.baseURL}/fonts/VIC-Regular.woff2) format('woff2'),
    url(${(e) => e.theme.baseURL}/fonts/VIC-Regular.woff) format('woff'),
    url(${(e) => e.theme.baseURL}/fonts/VIC-Regular.ttf) format('truetype');
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: VIC;
    src: local(VIC-Medium),
    url(${(e) => e.theme.baseURL}/fonts/VIC-Medium.woff2) format('woff2'),
    url(${(e) => e.theme.baseURL}/fonts/VIC-Medium.woff) format('woff'),
    url(${(e) => e.theme.baseURL}/fonts/VIC-Medium.ttf) format('truetype');
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: VIC;
    src: local(VIC-SemiBold),
    url(${(e) => e.theme.baseURL}/fonts/VIC-SemiBold.woff2) format('woff2'),
    url(${(e) => e.theme.baseURL}/fonts/VIC-SemiBold.woff) format('woff'),
    url(${(e) => e.theme.baseURL}/fonts/VIC-SemiBold.ttf) format('truetype');
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: VIC;
    src: local(VIC-Bold),
    url(${(e) => e.theme.baseURL}/fonts/VIC-Bold.woff2) format('woff2'),
    url(${(e) => e.theme.baseURL}/fonts/VIC-Bold.woff) format('woff'),
    url(${(e) => e.theme.baseURL}/fonts/VIC-Bold.ttf) format('truetype');
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  }

  html {
    height: 100%;
  }

  body {
    margin: 0;
    height: 100%;
  }

  #root {
    font-family: VIC,Verdana,Helvetica,sans-serif;
    font-smooth: always;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    height: 100%;
    background-color: ${o.blueGrey10};
  }

  .ReactModal__Body--open {
    overflow: hidden;
  }
`, n = r`${f}`;
export {
  n as GlobalStyles,
  f as StyledGlobalCss,
  n as default
};
